"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["size", "className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var IconClose = function IconClose(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? '' : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: size === '24' ? /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({}, rest), {}, {
      className: "'IconClose ".concat(className),
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": true,
      role: "button",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        opacity: "0.504227",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 10.9091L7.09091 6L6 7.09091L10.9091 12L6 16.9091L7.09091 18L12 13.0909L16.9091 18L18 16.9091L13.0909 12L18 7.09091L16.9091 6L12 10.9091Z",
          fill: "#767676"
        })
      })
    })) : /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({}, rest), {}, {
      className: "'IconClose ".concat(className),
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.78795 7.19088C8.39742 6.80036 7.76426 6.80036 7.37373 7.19088C6.98321 7.5814 6.98321 8.21457 7.37373 8.60509L14.5858 15.8172L7.05425 23.3487C6.66372 23.7393 6.66372 24.3724 7.05425 24.7629C7.44477 25.1535 8.07793 25.1535 8.46846 24.7629L16 17.2314L23.5316 24.7629C23.9221 25.1535 24.5553 25.1535 24.9458 24.7629C25.3363 24.3724 25.3363 23.7392 24.9458 23.3487L17.4142 15.8172L24.6263 8.6051C25.0168 8.21457 25.0168 7.58141 24.6263 7.19088C24.2358 6.80036 23.6026 6.80036 23.2121 7.19088L16 14.403L8.78795 7.19088Z",
        fill: "#767676"
      })
    }))
  });
};
var _default = IconClose;
exports["default"] = _default;